import { createEvent } from 'effector';
import { removeJWTInfo } from './methods';
import { addressesSign } from '../../addresses/sign';

export const logOut = createEvent();

let redirectInProgress = false;

logOut.watch(() => {
  if (redirectInProgress) return;

  const normalizePath = (p: string) =>
    p !== '/' && p.endsWith('/') ? p.slice(0, -1) : p;

  const pathnameRaw = window.location.pathname;
  const signPathRaw = addressesSign.signPath;

  const pathname = normalizePath(pathnameRaw);
  const signPath = normalizePath(signPathRaw);

  // Если уже на странице логина, не делаем редирект/перезагрузку.
  if (pathname === signPath) {
    return;
  }

  redirectInProgress = true;
  removeJWTInfo();

  // Делаем редирект на уровне браузера, чтобы не зависеть от
  // React Router и не попасть в reload-цикл на текущем роуте (/test).
  window.location.replace(signPath);
});
